import { CommonModule, DecimalPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingComponent } from './components/loading/loading.component';
import { PanelComponent } from './components/panel/panel.component';
import { TooltipContainerComponent } from './components/tooltip-container/tooltip-container.component';
import { TabbedPanelComponent } from './components/tabs/panel/tabbed-panel.component';
import { TabComponent } from './components/tabs/tab/tab.component';
import { TooltipDirective } from './directives/tooltip/tooltip.directive';
import { ComponentsHelperService } from './services/components-helper.service';
import { UsageService } from './services/usage.service';
import { PositionService } from './services/position.service';
import { CommentComponent } from './components/comment/comment.component';
import { OrderNumberComponent } from './components/order-number/order-number.component';

@NgModule({
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule],
  declarations: [
    LoadingComponent,
    PanelComponent,
    TabbedPanelComponent,
    TabComponent,
    TooltipContainerComponent,
    TooltipDirective,
    CommentComponent,
    OrderNumberComponent
  ],
  exports: [
    LoadingComponent,
    PanelComponent,
    TabbedPanelComponent,
    OrderNumberComponent,
    CommentComponent,
    TabComponent,
    TooltipDirective
  ],
  providers: [
    DecimalPipe,
    UsageService,
    PositionService,
    ComponentsHelperService
  ],
  bootstrap: [TooltipContainerComponent]
})
export class GamedaySharedModule {
  static forRoot(): ModuleWithProviders<GamedaySharedModule> {
    return {
      ngModule: GamedaySharedModule,
      providers: [UsageService, PositionService, ComponentsHelperService]
    };
  }
}
